import type React from "react";
import type { Channel } from "@/types/channel/channel";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { ChannelForm } from "./ChannelForm";

interface EditChannelDialogProps {
	channel: Channel | null;
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const EditChannelDialog: React.FC<EditChannelDialogProps> = ({
	channel,
	open,
	onOpenChange,
}) => {
	if (!channel) return null;

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>チャンネルを編集</DialogTitle>
				</DialogHeader>
				<ChannelForm channel={channel} onSuccess={() => onOpenChange(false)} />
			</DialogContent>
		</Dialog>
	);
};
